import ValidatorsMessages from '@ember-intl/cp-validations/validators/messages';

export default class ValidMessages extends ValidatorsMessages {
  prefix = 'validations.errors';
}
